import {CHAINCODE_MARRIOTT_BRANDS,CHAINCODE_HILTON_BRANDS,CHAINCODE_HYATT_BRANDS,CHAINCODE_ALL_BRANDS,PRICEGATEWAY_DEFAULT,PRICEGATEWAY_AMD, PRICEGATEWAY_SOJOURN} from '../constants'

let initStore = {
    facetLoading: false,
    facetError: false,
    svfacet_myloc:{
        my_esqueryText: "xx",
        my_dstqueryText:"yy",
        STARTDATE:"2023-10-24",
        ENDDATE: "2023-11-27" , 
        DT_FORMAT: "%Y-%m-%d",
        time_zone: "+01:00",
        esqueryChilds:"m0",
        esqueryInfants:"i0",
        esqueryAdults:"t1",
        esqueryCabin:"ECONOMY",
        svpageSize:5,
/*sjjun20 */

        pagenumber:1,
	     my_scr_id:''



      },
    facetData: {
       // pricegateway:PRICEGATEWAY_SOJOURN,
        pricegateway:PRICEGATEWAY_DEFAULT,
        chaincode :'marriott',

        rbBrand1Label : CHAINCODE_ALL_BRANDS,
        rbBrand2Label : CHAINCODE_MARRIOTT_BRANDS,
        rbBrand3Label:CHAINCODE_HILTON_BRANDS,
        rbBrand4Label:CHAINCODE_HYATT_BRANDS,
        //at start
        
        checkedAct1Label:'Hotel',
        checkedAct1:true,
        disabledAct1:false,

        checkedAct2Label:'Motel',
        checkedAct2:true,
        disabledAct2:false,

        checkedAct3Label:'Hostel',
        checkedAct3:true,
        disabledAct3:false,

        checkedAct4Label:'ApartHotel',
        checkedAct4:true,
        disabledAct4:false,

        checkedAct5Label:'Bread & Breakfast',
        checkedAct5:true,
        disabledAct5:false,

        checkedAct6Label:'Pousada',
        checkedAct6:true,
        disabledAct6:false,

        checkedAct7Label:'Vacation Townhouse',
        checkedAct7:true,
        disabledAct7:false,

        //at end
        checkedLmDisneyLabel:'Jet ski',
        checkedLmDisney:true,
        disabledLmDisney:false,

        checkedLmGolfLabel:'Golf',
        checkedLmGolf:true,
        disabledLmGolf:false,

        checkedLmSkiLabel:'Skiing',
        checkedLmSki:true,
        disabledLmSki:false,

         //svst start
         checkedStFiveLabel:'5 Stars',
         checkedStFive:true,
         disabledStFive:false,

         checkedStFourLabel:'4 Stars',
         checkedStFour:true,
         disabledStFour:false,

         checkedStThreeLabel:'3 Stars',
         checkedStThree:true,
         disabledStThree:false,

         checkedStTwoLabel:'2 Stars',
         checkedStTwo:true,
         disabledStTwo:false,
 

         //svst end
        //svrs start
        checkedRsExcellentLabel:'9+  Excellent',
        checkedRsExcellent:true,
        disabledRsExcellent:false,

        checkedRsGreatLabel:'8+ Great',
        checkedRsGreat:true,
        disabledRsGreat:false,

        checkedRsGoodLabel:'7+  Good',
        checkedRsGood:true,
        disabledRsGood:false,

        checkedRsOkayLabel:'5+ Okay',
        checkedRsOkay:true,
        disabledRsOkay:false,

        //svrs end

        //svfb start DBL.2D-NM
        

        checkedRtp1Label:"DBL.2D-NM",
        checkedRtp1:true,
        disabledRtp1:false,


        checkedRtp2Label:"DBL.2Q-2",
        checkedRtp2:true,
        disabledRtp2:false,

        checkedRtp3Label:"DBL.2D-SU",
        checkedRtp3:true,
        disabledRtp3:false,

        checkedRtp4Label:"DBL.2Q-1",
        checkedRtp4:true,
        disabledRtp4:false,

        checkedRtp5Label:"DBL.2D-EJ",
        checkedRtp5:true,
        disabledRtp5:false,

        checkedRtp6Label:"DBL.2D-SU",
        checkedRtp6:true,
        disabledRtp6:false,

        checkedRtp7Label: "DBL.2Q-EJ",
        checkedRtp7:true,
        disabledRtp7:false,

        checkedRtp8Label:"DBL.DX",
        checkedRtp8:true,
        disabledRtp8:false,

        //sj sgl
        checkedRtp9Label:"SGL.EJ",
        checkedRtp9:true,
        disabledRtp9:false,

        checkedRtp10Label:"SGL.H6",
        checkedRtp10:true,
        disabledRtp10:false,

        checkedRtp11Label: "SUI.2D",
        checkedRtp11:true,
        disabledRtp11:false,

        checkedRtp12Label:"SUI.2K",
        checkedRtp12:true,
        disabledRtp12:false,

        checkedRtp13Label:"SUI.65",
        checkedRtp13:true,
        disabledRtp13:false,


        //sj sglend

        checkedFbCancellationLabel:'2 DOUBLE BED',
        checkedFbCancellation:true,
        disabledFbCancellation:false,

        checkedFbInternetLabel:'1 DOUBLE BED',
        checkedFbInternet:true,
        disabledFbInternet:false,


        checkedFbParkingLabel:'1 ROOM',
        checkedFbParking:true,
        disabledFbParking:false,



        checkedFbBreakfastLabel:'1 SINGLE BED',
        checkedFbBreakfast:true,
        disabledFbBreakfast:false,

        //svfb end

        minBudgetPrice:20,
        maxBudgetPrice:800,
        valueSlider:100,

        checkedParkingLabel:'Free Parking',
        checkedParking:true,
        disabledParking:false,

        checkedWifiLabel:'Wifi',
        checkedWifi:true,
        disabledWifi:false,

        checkedRestaurantLabel:'Restaurant',
        checkedRestaurant:true,
        disabledRestaurant:false,

        checkedPetfriendlyabel:'pet Friendlly',
        checkedPetfriendly:true,
        disabledPetfriendly:false,

        checkedRoomserviceLabel:'Room Service',
        checkedRoomservice:true,
        disabledRoomservice:false,

        checkedFrontdeskLabel:'24 Hours Front Desk',
        checkedFrontdesk:true,
        disabledFrontdesk:false,

        checkedFitnessLabel:'Fitness Center',
        checkedFitness:true,
        disabledFitness:false,

        checkedNonsmokingLabel:'Non Smoking',
        checkedNonsmoking:true,
        disabledNonsmoking:false,

        checkedShuttleLabel:'Airport Shuttle',
        checkedShuttle:true,
        disabledShuttle:false,

        checkedFamilyroomsLabel:'Family Room',
        checkedFamilyrooms:true,
        disabledFamilyrooms:false,

        checkedSpaLabel:'Spa',
        checkedSpa:true,
        disabledSpa:false,

        checkedEvchargingLabel:'Electric Vehicle(EV) Charging',
        checkedEvcharging:true,
        disabledEvcharging:false,

        checkedWheelchairLabel:'Wheel Chair Accessibility',
        checkedWheelchair:true,
        disabledFWheelchair:false,

        checkedPoolLabel:'Swimming Pool',
        checkedPool:true,
        disabledPool:false

       
       
       

      
    }
}



export default (store = initStore, action) => {

    console.log(action);

    switch (action.type) {
        case "invfacet/SOJOURNS_LIST":
            console.log('tasks LIST_SOJOURNS reducer')
            return { ...store, facetData: action.payload.facetData, facetLoading: false, facetError: null }
        case "invfacet/SOJOURNS_BEGIN":
        
            return { ...store, facetData: [], facetLoading: true, facetError: null }
        case "invfacet/SOJOURNS_ERROR":
            return { ...store, facetData: [], facetError: action.error, facetLoading: false }
        case  "invfacet/SOJOURNS_SUCCESS":
            if(action.payload.svfacet_myloc){
                return { ...store,svfacet_myloc:action.payload.svfacet_myloc, facetData: action.payload.facetData, facetLoading: false}
 
            }else{
                return { ...store, facetData: action.payload.facetData, facetLoading: false}
 
            }
                       default:
            return store
    }
}